export let authStateData = {
  loading: false,
  error: false,
  success: false,
  message: "",
  accessToken: null,
  emailVerified: false,
};

if (localStorage.getItem("accessToken")) {
  authStateData = {
    ...authStateData,
    accessToken: localStorage.getItem("accessToken"),
  };
}

if (localStorage.getItem("emailVerified")) {
  authStateData = {
    ...authStateData,
    emailVerified: localStorage.getItem("emailVerified"),
  };
}
